module.exports = __webpack_public_path__ + "img/RuriStory_bk.bfed0bf7.png";